import { memo, createElement } from 'react';
import { fastCompare } from '@ux/perf';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var pipe = function pipe(fns) {
  return function (arg) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, arg);
  };
};
var compose = function compose(fns) {
  return pipe(fns.slice().reverse());
};

var withHooks = function withHooks(hooks) {
  return function (Component) {
    return pipe([pipe(hooks), Component]);
  };
};

var Compare;

(function (Compare) {
  Compare["FAST"] = "fast";
  Compare["SHALLOW"] = "shallow";
  Compare["NONE"] = "none";
})(Compare || (Compare = {}));

var _compareMap;
/* eslint-enable max-len */

var compareMap = (_compareMap = {}, _defineProperty(_compareMap, Compare.FAST, fastCompare), _defineProperty(_compareMap, Compare.SHALLOW, memo), _defineProperty(_compareMap, Compare.NONE, function (Component) {
  return Component;
}), _compareMap); // eslint-disable-next-line max-len

var enhance = function enhance(name) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (Array.isArray(opts)) {
    // eslint-disable-next-line no-param-reassign
    opts = {
      hooks: opts
    };
  }

  var _opts = opts,
      hocs = _opts.hocs,
      hooks = _opts.hooks,
      pipe = _opts.pipe,
      _opts$compare = _opts.compare,
      compare = _opts$compare === void 0 ? Compare.FAST : _opts$compare;
  var compareMethod = compareMap[compare];
  var enhancers = [compareMethod];

  if (pipe && pipe.length) {
    enhancers.push(compose(pipe));
  }

  if (hocs && hocs.length) {
    enhancers.push(compose(hocs));
  }

  if (hooks && hooks.length) {
    enhancers.push(withHooks(hooks));
  }

  var enhancer = compose(enhancers);
  return function (BaseComponent) {
    var Enhanced = enhancer(BaseComponent);

    var Wrapper = function Wrapper(props) {
      return createElement(Enhanced, props);
    };

    Wrapper.displayName = name;
    return Wrapper;
  };
};

export default enhance;
export { Compare, compose, pipe, withHooks };
